import { ClientJS } from "clientjs";
import { gapi } from "gapi-script";
import Cookies from "js-cookie";
import { useContext, useEffect, useState } from "react";
import { GoogleLogin } from "react-google-login";
import { useHistory } from "react-router-dom";
import { AdminContext } from "../../context/AdminContext";
import AdminServices from "../../services/AdminServices";
import StorageServices from "../../services/StorageServices";
import { getIP } from "../../utils/getIP";
import { notifyError, notifySuccess } from "../../utils/toast";
const platform = require("platform");

const GOOGLE_ID = process.env.REACT_APP_GOOGLE_ID;

export default function useGoogleAuth() {
  const client = new ClientJS();
  const { dispatch } = useContext(AdminContext);
  const history = useHistory();
  const [clientId, setClientId] = useState(GOOGLE_ID);

  useEffect(() => {
    if (!clientId) return;

    const initClient = () => {
      if (gapi && gapi.client) {
        gapi.client.init({
          clientId,
          scope: "",
        });
      }
    };

    gapi.load("client:auth2", initClient);
  }, [clientId]);

  const loginWithGoogle = async () => {
    const res = await AdminServices.googleSigninInit();
    setClientId(res?.google_oauth_client_id);
  };

  const onSuccess = async (res) => {
    const IP = await getIP();
    const payload = {
      app_id: `${process.env.REACT_APP_APP_ID}`,
      platform: "web",
      token_id: res.tokenId,
      phone: null,
      os: null,
      password: null,
      reg_channel: "web",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      fingerprint: {
        id: client.getFingerprint(),
        model: platform.description || null,
        os_version: platform.version || null,
        screen_width: window.innerWidth,
        screen_height: window.innerHeight,
        manufacturer: platform.manufacturer || null,
        is_physical_device: true,
        screen_resolution: client.getCurrentResolution(),
        firebase_device_id: null,
        ip: IP,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    };
    try {
      const response = await AdminServices.googleSignin(payload);
      const user = response.data.info;
      const userToken = response.token;
      notifySuccess(response.data.message);
      dispatch({ type: "USER_LOGIN", payload: user });
      Cookies.set("TD-User-Token", "Bearer " + userToken);
      StorageServices.set("adminInfo", JSON.stringify(user));
      StorageServices.set("logged-in-email", user.email);
      StorageServices.set("auth_method", "google");

      history.push("/select-store");
    } catch (err) {
      const message =
        err.response?.data?.message || err.message || err.toString();
      notifyError(message);
    }
  };

  const onFailure = (err) => {
    console.log("failed:", err);
  };

  return { loginWithGoogle, onSuccess, onFailure, GoogleLogin, clientId };
}
